// src/components/common/ErrorDisplay.jsx

import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

/**
 * Komponen untuk menampilkan pesan error yang lebih menarik.
 * @param {object} props
 * @param {string} [props.message] - Pesan error yang akan ditampilkan.
 * @param {function} [props.onRetry] - Fungsi yang akan dipanggil saat tombol "Coba Lagi" diklik.
 */
const ErrorDisplay = ({ message, onRetry }) => {
    return (
        <div className="flex flex-col items-center justify-center p-8 mt-16 text-center bg-white rounded-lg shadow-xl max-w-lg mx-auto">
            <div className="flex items-center justify-center w-24 h-24 text-red-600 bg-red-100 rounded-full animate-bounce">
                <ExclamationCircleIcon className="w-16 h-16" />
            </div>
            <h2 className="mt-6 text-3xl font-bold text-gray-900">Gagal memuat konten</h2>
            <p className="mt-2 text-md text-gray-600">
                {message || "Kami mohon maaf atas ketidaknyamanan ini. Silakan periksa koneksi internet Anda atau coba lagi nanti."}
            </p>
            {onRetry && (
                <button
                    onClick={onRetry}
                    className="mt-6 px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200"
                >
                    Coba Lagi
                </button>
            )}
        </div>
    );
};

export default ErrorDisplay;